import { render, staticRenderFns } from "./CreditPackageTransactionsTable.vue?vue&type=template&id=563ff2b8&"
import script from "./CreditPackageTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./CreditPackageTransactionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports